<template>
  <v-data-table
    v-if="relatorio.rotaApi"
    :headers="header"
    :items="values"
    class="elevation-1 tabelaDash"
    :items-per-page="5"
    :footer-props="{ itemsPerPageText: 'Itens por página' }"
  >
    <template slot="no-data"> Esse relatório ainda não possui dados </template>

    <template v-slot:item="{ item }">
      <tr>
        <td
          class="text-xs-right pa-4"
          v-for="(value, index) in Object.values(item)"
          :key="index"
        >
          <a
            :href="value"
            target="_blank"
            v-if="value && value.toString().startsWith('http')"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" v-bind="attrs" v-on="on"
                  >mdi-launch</v-icon
                >
              </template>
              Ir para o link
            </v-tooltip>
          </a>
          <template v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{ diminuirValue(transformValue(value)) }}</span
                >
              </template>
              <span>{{ transformValue(value) }} </span>
            </v-tooltip>
          </template>
        </td>
      </tr>
    </template>
    <template v-slot:footer.page-text="items">
      {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
    </template>
  </v-data-table>
  <div v-else class="px-4 py-4" style="height: 100%">
    <component
      v-bind:is="dinamicyComponent()"
      :filtros="filtros"
      ref="componentRef"
    >
    </component>
  </div>
</template>
<script>
import { administrativeDashboardAPI } from "@/modules/administrative-dashboard";
import { mapActions, mapGetters } from "vuex";
import GerarPdf from "@/helpers/geraXls";
import moment from "moment";

const component = {
  Radar: () => import("./components/RelAdminRadar.vue"),
};

export default {
  components: {},
  props: {
    relatorio: Object,
    filtros: { type: Object },
  },
  computed: {
    ...mapGetters(["loading", "isSala", "isParceiro"]),
  },
  data() {
    return {
      filtro: {},
      values: [],
      header: [],
      regional: [],
      regexDateWithT:
        /^(19|20)\d\d-(0[1-9]|1[012])-([012]\d|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,

      regexDate:
        /^\d{4}[\-\/\s]?((((0[13578])|(1[02]))[\-\/\s]?(([0-2][0-9])|(3[01])))|(((0[469])|(11))[\-\/\s]?(([0-2][0-9])|(30)))|(02[\-\/\s]?[0-2][0-9]))$/,
      regexDateWithHour:
        /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    dinamicyComponent() {
      return component[this.relatorio.component];
    },
    transformValue(item) {
      if (typeof item === "boolean") {
        if (item) return "Sim";
        return "Não";
      } else if (
        this.regexDate.test(item) ||
        this.regexDateWithHour.test(item) ||
        this.regexDateWithT.test(item)
      ) {
        return moment(item).format("DD/MM/YYYY");
      }

      return item;
    },
    diminuirValue(item) {
      if (item && item.length > 50) {
        return item.substring(0, 50) + "...";
      }

      return item;
    },
    someFilter() {
      return (
        this.filtro &&
        (this.filtro.Inicio ||
          this.filtro.Fim ||
          this.filtro.selo.length > 0 ||
          this.filtro.seloClienteOcultoGrupoId.length > 0 ||
          this.filtro.Solucoes.length > 0 ||
          this.filtro.GrupoSolucao ||
          this.filtro.GrupoId ||
          this.filtro.Status ||
          this.filtro.id_unidade_regional.length > 0 ||
          this.filtro.eixoId.length > 0 ||
          this.filtro.temaId.length > 0 ||
          this.filtro.UsuarioId ||
          this.filtro.uf.length > 0 ||
          (this.filtro.Municipios.length > 0 &&
            this.filtro.Municipios.filter((item) => item != 0).length > 0))
      );
    },
    load(relatorio) {
      this.setLoading(true);
      if (relatorio.id == 27 && this.filtro.Municipios.length == 0) {
        this.filtro.Municipios = [0];
      }
      if (relatorio.rotaApi)
        administrativeDashboardAPI
          .getPesquisa(relatorio.rotaApi, this.filtro)
          .then(({ data: dadosRelatorio }) => {
            this.header = relatorio.header;
            var dadosManipulados = dadosRelatorio.map((d) => {
              var newObject = {};
              this.header.forEach((item) => {
                newObject = { ...newObject, [item.value]: d[item.value] };
              });
              return newObject;
            });
            this.values = dadosManipulados;

            this.setLoading(false);
          })
          .catch((error) => {
            console.log("error: ", error);
            this.setLoading(false);
          });
    },
    filtrar(fil) {
      this.filtro = {
        Inicio: fil.dataInicial,
        Fim: fil.dataFim,
        Municipios: fil.municipioId,
        Solucoes: fil.solucaoId,
        GrupoSolucao: fil.grupoSolucaoId,
        GrupoId: fil.grupoId,
        Status: fil.statusId ? fil.statusId.map((item) => item.statusId) : null,
        id_unidade_regional: fil.id_unidade_regional,
        eixoId: fil.eixosIds ? fil.eixosIds.map((item) => item.eixoId) : null,
        temaId: fil.temaId,
        UsuarioId: fil.usuarioId,
        selo: fil.selo,
        uf: fil.uf ? fil.uf.map((item) => item.uf) : null,
        seloClienteOcultoGrupoId: fil.seloClienteOcultoGrupoId
          ? fil.seloClienteOcultoGrupoId
          : null,
      };
      if (
        (this.relatorio.onlyWithFilters && this.someFilter()) ||
        !this.relatorio.onlyWithFilters
      ) {
        if (this.relatorio.rotaApi) {
          if (
            (this.filtro.Inicio ||
              this.filtro.Fim ||
              this.filtro.selo.length > 0 ||
              this.filtro.seloClienteOcultoGrupoId.length > 0 ||
              this.filtro.Solucoes.length > 0 ||
              this.filtro.GrupoSolucao ||
              this.filtro.GrupoId ||
              this.filtro.Status ||
              this.filtro.id_unidade_regional.length > 0 ||
              this.filtro.eixoId.length > 0 ||
              this.filtro.temaId.length > 0 ||
              this.filtro.UsuarioId ||
              this.filtro.uf.length > 0) &&
            this.filtro.Municipios.length == 1 &&
            this.filtro.Municipios.filter((item) => item == 0).length > 0
          ) {
            this.filtro.Municipios = null;
          } else {
            this.filtro.Municipios =
              fil.municipioId ||
              (this.relatorio.defaultFilters &&
                this.relatorio.defaultFilters.municipioId);
          }

          this.load(this.relatorio);
        } else {
          this.$refs.componentRef.filtrar(fil);
        }
      }
    },
    gerarXlsx() {
      if (this.relatorio.rotaApi) {
        GerarPdf(this.values, this.relatorio.title, this.header);
      } else {
        this.$refs.componentRef.gerarPDF();
      }
    },
  },
  watch: {
    relatorio(val) {
      this.load(val);
    },
  },
  mounted() {
    if (this.relatorio.defaultFilters)
      this.filtro = {
        Inicio: this.relatorio.defaultFilters.dataInicial,
        Fim: this.relatorio.defaultFilters.dataFim,
        Municipios: this.relatorio.defaultFilters.municipioId,
        Solucoes: this.relatorio.defaultFilters.solucaoId,
        GrupoSolucao: this.relatorio.defaultFilters.grupoSolucaoId,
        GrupoId: this.relatorio.defaultFilters.grupoId,
        eixoId: this.relatorio.defaultFilters.eixosIds,
        temaId: this.relatorio.defaultFilters.temaId,
        UsuarioId: this.relatorio.defaultFilters.usuarioId,
        uf: this.relatorio.defaultFilters.uf,
        seloClienteOcultoGrupoId:
          this.relatorio.defaultFilters.seloClienteOcultoGrupoId,
        selo: this.relatorio.defaultFilters.selo,
      };

    if (!this.relatorio.onlyWithFilters) this.load(this.relatorio);
  },
};
</script>
<style lang="scss">
.tabelaDash th {
  white-space: nowrap;
}
</style>
